/**
 * Para birimini Türkiye standartlarına göre formatlar.
 * Örn: 1234567.89 -> 1.234.567,89 ₺
 * 
 * @param {number|string} amount Formatlanacak tutar
 * @param {boolean} includeSymbol Para birimi sembolü (₺) eklensin mi?
 * @returns {string} Formatlanmış para birimi
 */
const normalizeNumber = (value) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : 0;
  }

  if (typeof value === 'bigint') {
    return Number(value);
  }

  if (typeof value === 'string') {
    const cleaned = value.trim().replace(/[^\d,.-]/g, '');

    if (!cleaned) {
      return 0;
    }

    const lastDot = cleaned.lastIndexOf('.');
    const lastComma = cleaned.lastIndexOf(',');

    let normalized = cleaned;

    if (lastDot > -1 && lastComma > -1) {
      const decimalSeparator = lastDot > lastComma ? '.' : ',';
      normalized = decimalSeparator === '.'
        ? cleaned.replace(/,/g, '')
        : cleaned.replace(/\./g, '').replace(',', '.');
    } else if (lastComma > -1) {
      normalized = cleaned.replace(/\./g, '').replace(',', '.');
    }

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  return 0;
};

const manualFormatCurrency = (num) => {
  const sign = num < 0 ? '-' : '';
  const absolute = Math.abs(num);
  const [integerPart, decimalPart] = absolute.toFixed(2).split('.');
  const groupedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  return `${sign}${groupedInteger},${decimalPart}`;
};

export const formatCurrency = (amount, includeSymbol = true) => {
  const num = normalizeNumber(amount);
  const intlFormatted = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
  const shouldFallback =
    (!Number.isInteger(num) && !intlFormatted.includes(',')) ||
    (Math.abs(num) >= 1000 && !intlFormatted.includes('.'));
  const formatted = shouldFallback ? manualFormatCurrency(num) : intlFormatted;

  return includeSymbol ? `₺${formatted}` : formatted;
};

/**
 * Sayıyı binlik ayraçlı formatlar.
 * Örn: 1234567 -> 1.234.567
 * 
 * @param {number|string} num Formatlanacak sayı
 * @returns {string} Formatlanmış sayı
 */
export const formatNumber = (num) => {
  const n = normalizeNumber(num);
  const intlFormatted = new Intl.NumberFormat('tr-TR').format(n);

  if (Math.abs(n) >= 1000 && !intlFormatted.includes('.')) {
    return Math.trunc(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  return intlFormatted;
};
